/**
 * Serve as Ids and as plugin base paths.
 */
export enum EpDevPPluginIds {
  EpDevPPluginId = 'ep-devp',
  EpDevPEventsPluginId = 'ep-devp-events',
  EpDevPEventApisPluginId = 'ep-devp-event-apis',
  EpDevPEventApiProductsPluginId = 'ep-devp-event-api-products',
  EpDevPConsumerProductsPluginId = 'ep-devp-consumer-products',
  EpDevPConsumerAppsPluginId = 'ep-devp-consumer-apps',
  EpDevPVaultPluginId = 'ep-devp-vault',
  EpDevPSearchPluginId = 'ep-devp-search',
  EpDevPManageAppsPluginId = 'ep-devp-manage-apps',
  EpDevPTryMePluginId = 'ep-devp-try-me',
  EpDevPApprovalsPluginId = 'ep-devp-approvals',
  EpDevPOpenAPIPluginId = 'ep-devp-openapi',

}
/**
 * Set the document type the same as the plugin Id or create a map service
 */
export enum EpDevPDocumentTypes {
  EpDevPEventsDocumentType = EpDevPPluginIds.EpDevPEventsPluginId,
  EpDevPEventApisDocumentType = EpDevPPluginIds.EpDevPEventApisPluginId,
  EpDevPEventApiProductsDocumentType = EpDevPPluginIds.EpDevPEventApiProductsPluginId,
  EpDevPConsumerProductsDocumentType = EpDevPPluginIds.EpDevPConsumerProductsPluginId,
  EpDevPConsumerAppsDocumentType = EpDevPPluginIds.EpDevPConsumerAppsPluginId,
  EpDevPManageAppsDocumentType = EpDevPPluginIds.EpDevPManageAppsPluginId,
  EpDevPOpenAPIDocumentType = EpDevPPluginIds.EpDevPOpenAPIPluginId,
}

export enum EpDevPSingluarKinds {
  EpDevPEventsKindSingular = "Event",
  EpDevPEventApisKindSingular = "Event Api",
  EpDevPEventApiProductsKindSingular = "Event Api Product",
  EpDevPConsumerProductsKindSingular = "Product",
  EpDevPConsumerAppsKindSingular = "Application",
  EpDevPManageAppsKindSingular = "Consumer Application",
  EpDevPOpenAPIKindSingular = "OpenAPI App",
}

export enum EpDevPPluralKinds {
  EpDevPEventsKindPlural = "Events",
  EpDevPEventApisKindPlural = "Event Apis",
  EpDevPEventApiProductsKindPlural = "Event Api Products",
  EpDevPConsumerProductsKindPlural = "Products",
  EpDevPConsumerAppsKindPlural = "Applications",
  EpDevPManageAppsKindPlural = "Consumer Applications",
  EpDevPOpenAPIKindPlural = "OpenAPI App",
}
